import './BonusFans.sass';

import React, { FC, useCallback, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Button, Header, Placeholder, ScrollView } from '$uikit';
import { Api } from '$api';
import { useTranslator } from '$hooks';
import { mainActions } from '$store/main';
import { toastActions } from '$store/toast';
import { Loader, UserCell } from '$shared/components';
import { batchActions } from '$store';
import { inviteActions, inviteSelector } from '$store/invite';

export const BonusFans: FC = () => {
  const t = useTranslator();
  const dispatch = useDispatch();
  const [loadingStatus, setLoadingStatus] = useState('loading');
  const { bonusFans } = useSelector(inviteSelector);

  const loadData = useCallback(() => {
    setLoadingStatus('loading');
    Api.get<any, any>('/invite/bonus/fans')
      .then((data) => {
        dispatch(
          batchActions(
            mainActions.setUsers(data.users),
            inviteActions.setBonusFans(data.fans),
          ),
        );
        setLoadingStatus('');
      })
      .catch((e) => {
        dispatch(toastActions.setToastFail(e.message));
        setLoadingStatus('failed');
      });
  }, []);

  useMemo(() => {
    loadData();
  }, []);

  function renderContent() {
    if (loadingStatus === 'loading' && bonusFans.length === 0) {
      return <Loader isWrapped />;
    }

    if (loadingStatus === 'failed') {
      return (
        <Placeholder
          title={t('failed_title')}
          actions={
            <Button size="small" onClick={loadData}>
              {t('failed_button')}
            </Button>
          }
        >
          {t('failed_caption')}
        </Placeholder>
      );
    }

    if (bonusFans.length === 0) {
      return (
        <Placeholder centered>
          {t('bonus_fans_modal_empty')}
        </Placeholder>
      );
    }

    return (
      <>
        <div className="BonusFans__caption">{t('bonus_fans_modal_info')}</div>
        {bonusFans.map((fan) => (
          <UserCell key={fan} objectId={fan} />
        ))}
      </>
    );
  }

  return (
    <>
      <Header showBackButton>{t('bonus_fans_modal_title')}</Header>
      <ScrollView>{renderContent()}</ScrollView>
    </>
  );
};
